import { AriaLabels } from "@ibinder/ui-common-core";
import { select } from "node_modules/@ibinder/common-icons/dist";

export const getLabels = (t: (key: string) => string) => {
  const globalTemplate = 'globalTemplate.';

  return {
    save: t(`${globalTemplate}save`),
    useLocationMarkersOnDrawing: t(`${globalTemplate}useLocationMarkersOnDrawing`),
    locationOnDrawingheader: t(`${globalTemplate}locationOnDrawingheader`),
    locationOnDrawingHint: t(`${globalTemplate}locationOnDrawingHint`),
    start: t(`${globalTemplate}start`),
    end: t(`${globalTemplate}end`),
    title: t(`${globalTemplate}title`),
    workflowInstructions: t(`templateInstructions`),
    workflowTitleFormLabel: t(`${globalTemplate}workflowTitleFormLabel`),
    workflowDescriptionFormLabel: t(`${globalTemplate}workflowDescriptionFormLabel`),
    createHeaderText: t(`${globalTemplate}createHeaderText`),
    cancel: t(`${globalTemplate}cancel`),
    create: t(`${globalTemplate}create`),
    templateInformation: t(`${globalTemplate}templateInformation`),
    name: t(`${globalTemplate}name`),
    columnName: t(`${globalTemplate}columnName`),
    swimLane: t(`${globalTemplate}swimLane`),
    statesColumns: t(`statesAndColumns`),
    statesColumnsHint: t(`${globalTemplate}statesColumnsHint`),
    addColumn: t(`${globalTemplate}addColumn`),
    issueTemplateInputFields: t(`${globalTemplate}issueTemplateInputFields`),
    inputFieldHeader: t(`${globalTemplate}inputFieldHeader`),
    fieldName: t(`${globalTemplate}fieldName`),
    fieldType: t(`${globalTemplate}fieldType`),
    required: t(`requiredField`),
    selectFieldOptionsHeader: t(`${globalTemplate}selectFieldOptionsHeader`),
    addOption: t(`${globalTemplate}addOption`),
    addInputField: t(`${globalTemplate}addInputField`),
    instructions: t(`${globalTemplate}instructions`),
    contentGroup: t(`contentGroup`),
    entrepreneur: t(`${globalTemplate}entrepreneur`),
    UserDefinedCategory: t(`${globalTemplate}UserDefinedCategory`),
    noCategory: t(`${globalTemplate}noCategory`),
    RoleTypeName: t(`${globalTemplate}RoleTypeName`),
    flagTypes: t(`${globalTemplate}flagTypes`),
    flagType: t(`${globalTemplate}flagType`),
    locationOnDrawing: t(`${globalTemplate}locationOnDrawing`),
    statusColumn: t(`${globalTemplate}statusColumn`),
    statusColumnHint: t(`${globalTemplate}statusColumnHint`),
    flagTypesHint: t(`${globalTemplate}flagTypesHint`),
    addFlagType: t(`${globalTemplate}addFlagType`),
    workflowRoles: t(`${globalTemplate}workflowRoles`),
    workflowRolesHint: t(`${globalTemplate}workflowRolesHint`),
    useResponsibleFieldInIssues: t(`${globalTemplate}useResponsibleFieldInIssues`),
    rolesAllowedLabel: t(`${globalTemplate}rolesAllowedLabel`),
    creator: t(`${globalTemplate}creator`),
    assignee: t(`${globalTemplate}assignee`),
    responsible: t(`${globalTemplate}responsible`),
    confirmChangeStatus: t(`${globalTemplate}confirmChangeStatus`),
    MessageNone: t(`${globalTemplate}messageNone`),
    MessageRequired: t(`${globalTemplate}messageRequired`),
    MessageOptional: t(`${globalTemplate}messageOptional`),
    createNew: t(`${globalTemplate}createNew`),
    edit: t(`${globalTemplate}edit`),
    duplicate: t(`${globalTemplate}duplicate`),
    createNewTemplate: t(`${globalTemplate}createNewTemplate`), 
    editWorkflowTemplate: t(`${globalTemplate}editWorkflowTemplate`),
    market: t(`${globalTemplate}market`),
    selectMarket: t(`${globalTemplate}selectMarket`),
    all: t(`${globalTemplate}all`),
    ParticipantOption: t(`ParticipantOption`),
    DatePicker: t(`DatePicker`),
    Option: t(`Option`),
    TextAreaForm: t(`TextAreaForm`),
    TextForm: t(`TextForm`),
    view:t(`view`),
    ariaLabels: {
      collapse: t(`${globalTemplate}ariaLabels.collapse`),
      expand: t(`${globalTemplate}ariaLabels.expand`),
      changeSortOrder: t(`${globalTemplate}ariaLabels.changeSortOrder`),
    } as AriaLabels,
  };
};
